"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCURACY_DETAILS_TYPE = void 0;
exports.ACCURACY_DETAILS_TYPE = {
    LIFT: 'lift',
    CUMULATIVE_LIFT: 'cumulativeLift',
    RESPONSE: 'response',
    CUMULATIVE_RESPONSE: 'cumulativeResponse',
    CAPTURED_RESPONSE: 'capturedResponse',
    CUMULATIVE_CAPTURED_RESPONSE: 'cumulativeCapturedResponse',
    ROC: 'roc',
    MISCLASSIFICATION: 'misclassification',
    PREDICTED_VALUES_DISTRIBUTION: 'predictedValuesDistribution',
};
//# sourceMappingURL=accuracyCharts.js.map